/* Neue Handy-Produktseite (D9), BETA V12, 01.11.2026. Code: sections/hnds-pdp-v12.liquid.
   Galerie (Punkte + Glas-Pille folgen dem Wischen, Glas hell/dunkel nach Bildhelligkeit), Klappfelder, Fenster "So verstellst du ihn",
   Knopf = Klick auf den Warenkorb-Knopf des (ausgeblendeten) Abschnitts "main", "Zweiter Ring dazu" = Ringbundle-Fenster.
   Seit 01.11.2026 abends auch Desktop ab 741 px (R8D): Pillen je Kachel, Produktvideo, Kundenvideos, mitlaufender Kaufbereich, Kaufleiste (nur dort aktiv). */
(function () {
  'use strict';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DESK_MQ = window.matchMedia('(min-width: 741px)');

  function Hpv(root) {
    var main = document.getElementById(root.getAttribute('data-main'));
    var track = root.querySelector('[data-hpv-track]');
    var slides = root.querySelectorAll('[data-hpv-slide]');
    var pills = root.querySelectorAll('[data-hpv-pill]');
    var dots = root.querySelectorAll('[data-hpv-dot]');
    var current = 0;
    var DESK = DESK_MQ.matches;
    var zb = root.querySelector('[data-hpv-zb]');
    /* Vergroessern-Knopf (Ketten-Set): Glas hell/dunkel wie die Pille des sichtbaren Bilds */
    function syncZb() { if (zb) zb.classList.toggle('is-dark', !!(pills[current] && pills[current].classList.contains('is-dark'))); }

    /* ---------- Galerie ---------- */
    function show(k) {
      if (k === current || k < 0 || k >= slides.length) return;
      current = k;
      for (var i = 0; i < pills.length; i++) pills[i].classList.toggle('is-on', i === k);
      for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-on', j === k);
      syncZb();
      var v = slides[k].querySelector('video');
      Array.prototype.forEach.call(root.querySelectorAll('.hpv-gal__slide video'), function (x) { if (x !== v) x.pause(); });
      if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth || 1;
        show(Math.round(track.scrollLeft / w));
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var k = Math.max(0, Math.min(slides.length - 1, current + (e.key === 'ArrowRight' ? 1 : -1)));
      track.scrollTo({ left: k * track.clientWidth, behavior: REDUCED.matches ? 'auto' : 'smooth' });
    });

    /* Glas hell oder dunkel: Helligkeit im Bereich der Pille messen (kleines Bild, crossorigin). Klappt es nicht, bleibt helles Glas. */
    function measure(k) {
      var img = slides[k] && slides[k].querySelector('img[data-measure]');
      var pill = pills[k];
      if (!img || !pill) return;
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var iw = probe.naturalWidth, ih = probe.naturalHeight;
          var W = track.clientWidth, H = track.clientHeight;
          var s = Math.max(W / iw, H / ih);
          var slide = slides[k];
          var ox = (W - iw * s) / 2;
          /* senkrechter Ausschnitt aus object-position (unten bei --bottom, eigener Wert beim Set) */
          var opy = (getComputedStyle(img).objectPosition || '').split(' ')[1] || '50%';
          var fy = /%$/.test(opy) ? parseFloat(opy) / 100 : 0.5;
          var oy = (H - ih * s) * fy;
          var z = slide.classList.contains('hpv-gal__slide--small') ? 0.93 : 1;   /* verkleinert von oben Mitte aus */
          /* Bereich der Pille (unten oder oben links), so breit wie sie ist, zurueckgerechnet in Bildpunkte */
          var tr = track.getBoundingClientRect(), pr = pill.getBoundingClientRect();
          var px = pr.left - tr.left, py = pr.top - tr.top, pw = Math.max(pr.width, 120), ph = pr.height || 30;
          var ix = function (x) { return ((x - W / 2) / z + W / 2 - ox) / s; };
          var iy = function (y) { return (y / z - oy) / s; };
          var x0 = ix(px), x1 = ix(px + pw);
          var y0 = iy(py), y1 = iy(py + ph);
          x0 = Math.max(0, Math.floor(x0)); y0 = Math.max(0, Math.floor(y0));
          var cw = Math.max(1, Math.min(iw - x0, Math.ceil(x1 - x0))), ch = Math.max(1, Math.min(ih - y0, Math.ceil(y1 - y0)));
          var c = document.createElement('canvas');
          c.width = cw; c.height = ch;
          var ctx = c.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(probe, x0, y0, cw, ch, 0, 0, cw, ch);
          var d = ctx.getImageData(0, 0, cw, ch).data, sum = 0, n = 0;
          for (var i = 0; i < d.length; i += 4) { sum += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]; n++; }
          var lum = sum / n / 255;
          pill.setAttribute('data-lum', lum.toFixed(2));
          pill.classList.toggle('is-dark', lum < 0.5);
          if (k === current) syncZb();
        } catch (e) { /* kein Zugriff aufs Bild: helles Glas bleibt */ }
      };
      probe.src = img.getAttribute('data-measure');
    }
    if (!DESK) {
      measure(0);
      (window.requestIdleCallback || function (fn) { return setTimeout(fn, 400); })(function () {
        for (var k = 1; k < slides.length; k++) measure(k);
      });
    }

    /* ---------- Bewertung: Tipp oeffnet das REVIEWS.io-Fenster (reviews_fade) wie im Live-Theme, ueber das Bewertungs-Snippet
       im ausgeblendeten Abschnitt "main". Ist es nicht da (App nicht geladen), scrollt der Tipp zu den Produktbewertungen. ---------- */
    var toReviews = root.querySelector('[data-hpv-to-reviews]');
    if (toReviews) toReviews.addEventListener('click', function () {
      var snippet = main && main.querySelector('.ruk_rating_snippet');
      var count = snippet && snippet.querySelector('.ruk-rating-snippet-count');
      if (count && document.getElementById('reviews_fade')) { count.click(); return; }
      var target = document.querySelector('reviewsio-product-reviews-widget') || document.querySelector('[id*="1715598674424883d6"]');
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: top, behavior: REDUCED.matches ? 'auto' : 'smooth' });
    });

    /* ---------- Shop-Bewertung live von REVIEWS.io (wie das Karussell), sonst bleibt der Wert aus den Einstellungen ---------- */
    var sr = root.querySelector('[data-hpv-store-rating]');
    var store = root.getAttribute('data-reviews-store');
    function loadStore() {
      if (!sr || !store || !window.fetch) return;
      fetch('https://api.reviews.io/timeline/data?type=store_review&store=' + encodeURIComponent(store) + '&page=1&per_page=1')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var st = j && j.storeStats;
          if (!st || !st.review_count) return;
          var avg = Math.round(parseFloat(st.average_rating) * 10) / 10;
          var cnt = Number(st.review_count).toLocaleString('de-DE');
          Array.prototype.forEach.call(root.querySelectorAll('[data-hpv-store-rating]'), function (el) { if (!isNaN(avg)) el.textContent = avg.toFixed(1).replace('.', ','); });
          Array.prototype.forEach.call(root.querySelectorAll('[data-hpv-store-count]'), function (el) { el.textContent = cnt; });
        })
        .catch(function () {});
    }
    if ('IntersectionObserver' in window && sr) {
      var spSeen = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        spSeen.disconnect();
        loadStore();
      }, { rootMargin: '200px' });
      spSeen.observe(sr);
    } else loadStore();

    /* ---------- Auswahl (Kacheln): Variante, Preis, Ersparnis, Geschenk-Kachel, Lager und die Variante im ausgeblendeten "main" ---------- */
    var vData = [];
    var vEl = root.querySelector('[data-hpv-variants]');
    if (vEl) { try { vData = JSON.parse(vEl.textContent); } catch (e) { vData = []; } }
    var opts = root.querySelectorAll('[data-hpv-opt]');
    var optLabel = root.querySelector('[data-hpv-opt-label]');
    var priceEl = root.querySelector('[data-hpv-price]');
    var saveEl = root.querySelector('[data-hpv-save]');
    var giftEl = root.querySelector('[data-hpv-gift]');
    var stockEl = root.querySelector('[data-hpv-stock]');
    var atcEl = root.querySelector('[data-hpv-atc]');
    var barPrice = root.querySelector('[data-hpv-bar-price]');
    var barAtc = root.querySelector('[data-hpv-bar-atc]');
    var curOpt = -1;

    /* Variante im Theme-Abschnitt "main" waehlen: Options-Feld anklicken (Focal aktualisiert dann sein Formular), sonst das Formularfeld direkt */
    function selectInMain(v) {
      if (!main || !v) return;
      var radios = main.querySelectorAll('input[type="radio"][name="option1"]');
      var hit = null;
      for (var i = 0; i < radios.length; i++) if (radios[i].value === v.value) hit = radios[i];
      if (hit && !hit.checked) {
        hit.checked = true;
        hit.dispatchEvent(new Event('change', { bubbles: true }));
      }
      Array.prototype.forEach.call(main.querySelectorAll('form[action*="/cart/add"] [name="id"], select[name="id"]'), function (f) {
        if (f.value !== String(v.id)) {
          if (f.tagName === 'SELECT') { f.value = String(v.id); f.dispatchEvent(new Event('change', { bubbles: true })); }
          else if (!f.disabled) f.value = String(v.id);
        }
      });
    }

    function pick(k, fromUser) {
      var v = vData[k];
      if (!v) return;
      curOpt = k;
      for (var i = 0; i < opts.length; i++) {
        opts[i].classList.toggle('is-on', i === k);
        opts[i].setAttribute('aria-pressed', i === k ? 'true' : 'false');
      }
      if (optLabel) optLabel.textContent = v.label;
      if (priceEl) priceEl.innerHTML = (v.was ? '<s class="hpv-price__was">' + v.was + '</s>' : '') + v.price;
      if (saveEl) { saveEl.innerHTML = v.save; saveEl.hidden = !v.save; }
      if (giftEl) giftEl.hidden = !v.gift;
      if (stockEl) stockEl.hidden = !v.avail;
      if (atcEl) {
        atcEl.disabled = !v.avail;
        atcEl.textContent = v.avail ? atcEl.getAttribute('data-label-add') : atcEl.getAttribute('data-label-out');
      }
      if (barPrice && priceEl) barPrice.innerHTML = priceEl.innerHTML;
      if (barAtc && atcEl) { barAtc.disabled = atcEl.disabled; barAtc.textContent = atcEl.textContent; }
      root.setAttribute('data-variant', v.id);
      if (fromUser) selectInMain(v);
    }
    if (opts.length && vData.length) {
      var start = 0;
      for (var oi = 0; oi < opts.length; oi++) if (opts[oi].classList.contains('is-on')) start = oi;
      pick(start, false);
      Array.prototype.forEach.call(opts, function (b) {
        b.addEventListener('click', function () { pick(+b.getAttribute('data-hpv-opt'), true); });
      });
    }

    /* Fest gewaehlte Variante (z. B. Pero "One Size"): auch im "main" waehlen */
    var forced = root.getAttribute('data-force-variant');
    if (forced && main) {
      var fv = main.querySelectorAll('input[type="radio"][name="option1"]');
      var sel = main.querySelector('select[name="id"]');
      var title = '';
      if (sel) for (var si = 0; si < sel.options.length; si++) if (sel.options[si].value === forced) title = sel.options[si].text.split(' - ')[0].trim();
      for (var fi = 0; fi < fv.length; fi++) {
        if (title && fv[fi].value === title && !fv[fi].checked) { fv[fi].checked = true; fv[fi].dispatchEvent(new Event('change', { bubbles: true })); }
      }
      if (sel && sel.value !== forced) { sel.value = forced; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    }

    /* ---------- Knopf: Warenkorb-Knopf des Theme-Abschnitts klicken (Schublade, Gratis-Armband, Tracking bleiben wie heute) ---------- */
    var atc = root.querySelector('[data-hpv-atc]');
    if (atc) atc.addEventListener('click', function () {
      var real = main && main.querySelector('form[action*="/cart/add"] [type="submit"]');
      if (!real) {
        /* Notweg: normales Formular an /cart/add */
        var f = document.createElement('form');
        f.method = 'post'; f.action = '/cart/add';
        f.innerHTML = '<input type="hidden" name="id" value="' + root.getAttribute('data-variant') + '"><input type="hidden" name="quantity" value="1">';
        document.body.appendChild(f);
        f.submit();
        return;
      }
      atc.classList.add('is-busy');
      atc.setAttribute('aria-busy', 'true');
      var done = function () {
        atc.classList.remove('is-busy');
        atc.removeAttribute('aria-busy');
        document.removeEventListener('variant:added', done);
        document.documentElement.removeEventListener('variant:added', done);
      };
      document.addEventListener('variant:added', done);
      document.documentElement.addEventListener('variant:added', done);
      setTimeout(done, 4000);
      real.click();
    });

    /* ---------- "Zweiter Ring dazu": Ringbundle-Fenster aus hnds-pdp-bundle oeffnen ---------- */
    var bundle = root.querySelector('[data-hpv-bundle]');
    var entry = main && main.querySelector('[data-hnds-pb-open]');
    if (bundle && entry) {
      bundle.hidden = false;
      bundle.addEventListener('pointerdown', function () { entry.dispatchEvent(new Event('pointerdown')); }, { passive: true });
      bundle.addEventListener('click', function () {
        /* Schalter vorher "an", dann oeffnet das Fenster ohne Wartezeit (der Schalter selbst ist am Handy nicht zu sehen) */
        entry.classList.add('is-on');
        entry.click();
      });
    }

    var isSet = root.hasAttribute('data-hpv-set');
    if (DESK) Desk(root, atc);
    if (isSet) SetPick();

    /* ---------- Ketten-Set: zwei Reihen Kacheln waehlen die Variante; Kombi-Bild, Pille, Preis, Ersparnis, Geschenk, Lager und Warenkorb-Variante folgen ---------- */
    function SetPick() {
      var sv = [];
      var se = root.querySelector('[data-hpv-set-variants]');
      if (se) { try { sv = JSON.parse(se.textContent); } catch (e) { sv = []; } }
      var tiles = root.querySelectorAll('[data-hpv-set-opt]');
      var img = root.querySelector('[data-hpv-set-img]');
      var pillTxt = root.querySelector('[data-hpv-set-pill]');
      var labs = { 1: root.querySelector('[data-hpv-set-lab="1"]'), 2: root.querySelector('[data-hpv-set-lab="2"]') };
      var sel = { 1: '', 2: '' };
      Array.prototype.forEach.call(tiles, function (t) { if (t.classList.contains('is-on')) sel[t.getAttribute('data-hpv-set-opt')] = t.getAttribute('data-v'); });
      function clean(v) { return String(v || '').replace(' (Beliebt)', '').trim(); }
      var pill1 = root.getAttribute('data-set-pill1') || '[wert]', pill2 = root.getAttribute('data-set-pill2') || '[wert]';
      function choose(row, val) {
        sel[row] = val;
        var v = null;
        for (var i = 0; i < sv.length; i++) if (sv[i].o1 === sel[1] && sv[i].o2 === sel[2]) v = sv[i];
        if (!v) return;
        Array.prototype.forEach.call(tiles, function (t) {
          var on = sel[t.getAttribute('data-hpv-set-opt')] === t.getAttribute('data-v');
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (labs[1]) labs[1].textContent = clean(v.o1);
        if (labs[2]) labs[2].textContent = clean(v.o2);
        if (pillTxt) pillTxt.textContent = clean(v.o1) + ' + ' + clean(v.o2);
        var tp0 = root.querySelector('[data-hpv-set-tp="0"]');
        if (tp0) tp0.textContent = clean(v.o1) + ' + ' + clean(v.o2);
        var barImg = root.querySelector('[data-hpv-bar-img]');
        if (barImg) barImg.src = v.m;
        if (img) {
          img.srcset = [390, 585, 780, 1170].map(function (w) { return v.img.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(', ');
          img.src = v.img;
          img.style.objectPosition = '50% ' + v.pos + '%';
          img.setAttribute('data-measure', v.m);
          measure(0);
        }
        var big = document.querySelector('[data-hpv-set-big]');
        if (big) { big.setAttribute('data-src', v.big); if (big.getAttribute('src')) big.src = v.big; }
        var th0 = document.querySelector('[data-hpv-set-th0]');
        if (th0) th0.src = v.m;
        /* Bild 2/3: Einzelbild des gewaehlten Anhaengers / der Kette, Pillen-Text, Grossansicht und Vorschaubild */
        [1, 2].forEach(function (row) {
          var tile = null;
          Array.prototype.forEach.call(tiles, function (t) { if (t.getAttribute('data-hpv-set-opt') === String(row) && t.classList.contains('is-on')) tile = t; });
          if (!tile || !tile.getAttribute('data-img')) return;
          var si = root.querySelector('[data-hpv-set-single="' + row + '"]');
          if (si) {
            var u = tile.getAttribute('data-img');
            si.srcset = [390, 585, 780, 1170].map(function (w) { return u.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w'; }).join(', ');
            si.src = u;
            si.setAttribute('data-measure', tile.getAttribute('data-m'));
            measure(row);
          }
          var ptxt = (row === 1 ? pill1 : pill2).replace('[wert]', tile.getAttribute('data-n'));
          var pt = root.querySelector('[data-hpv-set-pill' + row + ']');
          if (pt) pt.textContent = ptxt;
          var tpd = root.querySelector('[data-hpv-set-tp="' + row + '"]');
          if (tpd) tpd.textContent = ptxt;
          var b2 = document.querySelector('[data-hpv-set-big' + row + ']');
          if (b2) { b2.setAttribute('data-src', tile.getAttribute('data-big')); if (b2.getAttribute('src')) b2.src = tile.getAttribute('data-big'); }
          var tb = document.querySelector('[data-hpv-set-th' + row + ']');
          if (tb) tb.src = tile.getAttribute('data-m');
        });
        track.scrollTo({ left: 0 });
        /* Desktop: Pillen der drei Bilder neu messen, sobald die neuen Bilder geladen sind */
        if (DESK_MQ.matches && root.__hpvTiles) setTimeout(root.__hpvTiles, 60);
        if (priceEl) priceEl.innerHTML = (v.was ? '<s class="hpv-price__was">' + v.was + '</s>' : '') + v.price;
        if (saveEl) { saveEl.innerHTML = v.save; saveEl.hidden = !v.save; }
        if (giftEl) giftEl.hidden = !v.gift;
        if (stockEl) stockEl.hidden = !v.avail;
        if (atcEl) {
          atcEl.disabled = !v.avail;
          atcEl.textContent = v.avail ? atcEl.getAttribute('data-label-add') : atcEl.getAttribute('data-label-out');
        }
        if (barPrice && priceEl) barPrice.innerHTML = priceEl.innerHTML;
        if (barAtc && atcEl) { barAtc.disabled = atcEl.disabled; barAtc.textContent = atcEl.textContent; }
        root.setAttribute('data-variant', v.id);
        /* Variante im ausgeblendeten "main": beide Options-Felder, dann das id-Feld */
        if (main) {
          ['option1', 'option2'].forEach(function (n, i) {
            var want = i === 0 ? v.o1 : v.o2;
            Array.prototype.forEach.call(main.querySelectorAll('input[type="radio"][name="' + n + '"]'), function (r) {
              if (r.value === want && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
            });
          });
          Array.prototype.forEach.call(main.querySelectorAll('form[action*="/cart/add"] [name="id"], select[name="id"]'), function (f) {
            if (f.value !== String(v.id)) {
              if (f.tagName === 'SELECT') { f.value = String(v.id); f.dispatchEvent(new Event('change', { bubbles: true })); }
              else if (!f.disabled) f.value = String(v.id);
            }
          });
        }
      }
      Array.prototype.forEach.call(tiles, function (t) {
        t.addEventListener('click', function () { choose(t.getAttribute('data-hpv-set-opt'), t.getAttribute('data-v')); });
      });
    }

    /* ---------- Handy: Video-Blase oeffnet das Vollbild-Video ---------- */
    var vdOpen = root.querySelector('[data-hpv-vd-open]');
    var vdo = root.querySelector('[data-hpv-vdo]');
    if (vdOpen && vdo) VideoFull(vdOpen, vdo);

    /* ---------- Handy: Tipp aufs Galeriebild oeffnet die Grossansicht (B1) ---------- */
    var iv = root.querySelector('[data-hpv-iv]');
    if (iv && !DESK) ImageView(iv, track);

    /* ---------- Klappfelder ---------- */
    Array.prototype.forEach.call(root.querySelectorAll('[data-hpv-acc]'), function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.getElementById(btn.getAttribute('aria-controls')).hidden = !open;
      });
    });

    /* ---------- Fenster: "info" (So verstellst du ihn / So passt du ihn an) und "guide" (Größenhilfe mit Wahl) ---------- */
    Array.prototype.forEach.call(root.querySelectorAll('[data-hpv-layer]'), function (layer) {
      var name = layer.getAttribute('data-hpv-layer') || 'info';
      var opener = root.querySelector('[data-hpv-sheet-open="' + name + '"]');
      if (opener) makeSheet(layer, opener, name);
    });

    function makeSheet(layer, opener, name) {
      document.body.appendChild(layer);
      var sheet = layer.querySelector('[data-hpv-sheet]');
      /* Ring-Animation (SMIL): nur bei offenem Fenster abspielen, bei "Bewegung reduzieren" Standbild nach dem Einblenden (1 s) */
      var anim = layer.querySelector('[data-hpv-anim]');
      var STILL = 1;
      function animStill() { try { anim.pauseAnimations(); anim.setCurrentTime(STILL); } catch (e) {} }
      if (anim) animStill();
      var isOpen = false, closeTimer = 0;
      var openSheet = function () {
        if (isOpen) return;
        isOpen = true;
        clearTimeout(closeTimer);
        layer.hidden = false;
        document.documentElement.classList.add('hpv-locked');
        sheet.style.transform = '';
        void layer.offsetWidth;
        layer.classList.add('is-open');
        sheet.focus({ preventScroll: true });
        if (anim) {
          if (REDUCED.matches) animStill();
          else { try { anim.setCurrentTime(0); anim.unpauseAnimations(); } catch (e) {} }
        }
      };
      var closeSheet = function () {
        if (!isOpen) return;
        isOpen = false;
        layer.classList.remove('is-open');
        sheet.style.transform = '';
        document.documentElement.classList.remove('hpv-locked');
        closeTimer = setTimeout(function () { layer.hidden = true; if (anim) animStill(); }, REDUCED.matches ? 0 : 320);
        opener.focus({ preventScroll: true });
      };
      /* Groessenhilfe: Wahl im Fenster, "Uebernehmen" setzt sie */
      var gopts = layer.querySelectorAll('[data-hpv-gopt]');
      var pending = -1;
      function markG(k) {
        pending = k;
        for (var i = 0; i < gopts.length; i++) gopts[i].classList.toggle('is-on', i === k);
      }
      Array.prototype.forEach.call(gopts, function (b) {
        b.addEventListener('click', function () { markG(+b.getAttribute('data-hpv-gopt')); });
      });
      var apply = layer.querySelector('[data-hpv-guide-apply]');
      if (apply) apply.addEventListener('click', function () {
        if (pending > -1 && pending !== curOpt) pick(pending, true);
        closeSheet();
      });
      opener.addEventListener('click', function () {
        if (gopts.length) markG(curOpt > -1 ? curOpt : 0);
        openSheet();
      });
      layer.addEventListener('click', function (e) { if (e.target.closest('[data-hpv-sheet-close]')) closeSheet(); });
      layer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeSheet();
        if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('hpv-sheet__grip')) { e.preventDefault(); closeSheet(); }
      });
      /* Wisch nach unten schliesst (nur wenn das Fenster oben steht) */
      var y0 = null, dy = 0;
      sheet.addEventListener('touchstart', function (e) {
        if (sheet.scrollTop > 0) { y0 = null; return; }
        y0 = e.touches[0].clientY; dy = 0;
        sheet.classList.add('is-dragging');
      }, { passive: true });
      sheet.addEventListener('touchmove', function (e) {
        if (y0 === null) return;
        dy = Math.max(0, e.touches[0].clientY - y0);
        sheet.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true });
      var endDrag = function () {
        if (y0 === null) return;
        y0 = null;
        sheet.classList.remove('is-dragging');
        if (dy > 80) closeSheet();
        else sheet.style.transform = '';
      };
      sheet.addEventListener('touchend', endDrag);
      sheet.addEventListener('touchcancel', endDrag);
    }
  }

  /* ---------- Video im schwarzen Sheet von unten (Handy, S1): Seite dahinter abgedunkelt. Tipp aufs Video = Pause/Weiter,
     Ton-Knopf, Fortschrittsbalken. Schliessen: X, Tipp ins Dunkle, nach unten ziehen (ab 25 % der Hoehe), Escape,
     Zurueck-Geste (Eintrag im Verlauf beim Oeffnen). Video laedt erst beim Oeffnen. ---------- */
  function VideoFull(opener, layer) {
    document.body.appendChild(layer);
    var sheet = layer.querySelector('[data-hpv-vdo-sheet]');
    var bg = layer.querySelector('[data-hpv-vdo-bg]');
    var v = layer.querySelector('video');
    var x = layer.querySelector('[data-hpv-vdo-close]');
    var snd = layer.querySelector('[data-hpv-vdo-sound]');
    var prog = layer.querySelector('[data-hpv-vdo-prog]');
    var isOpen = false, pushed = false, raf = 0, timer = 0;

    function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function tick() {
      if (!isOpen) return;
      if (v.duration) prog.style.width = Math.min(100, v.currentTime / v.duration * 100) + '%';
      raf = requestAnimationFrame(tick);
    }
    function mark() { layer.classList.toggle('is-paused', v.paused && isOpen); }
    v.addEventListener('play', mark);
    v.addEventListener('pause', mark);
    v.addEventListener('error', function () {
      var hd = v.getAttribute('data-src-hd');
      if (!hd || v.getAttribute('src') === hd) return;
      v.src = hd;
      if (isOpen) play();
    });

    function open() {
      if (isOpen) return;
      isOpen = true;
      clearTimeout(timer);
      if (!v.getAttribute('src')) v.src = v.getAttribute('data-src');
      v.muted = true;
      snd.setAttribute('aria-pressed', 'false');
      snd.setAttribute('aria-label', snd.getAttribute('data-l-on'));
      layer.hidden = false;
      sheet.style.transform = '';
      bg.style.opacity = '';
      document.documentElement.classList.add('hpv-locked');
      void layer.offsetWidth;
      layer.classList.add('is-open');
      sheet.focus({ preventScroll: true });
      try { history.pushState({ hpvVideo: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
      play();
      raf = requestAnimationFrame(tick);
    }
    function shut() {
      if (!isOpen) return;
      isOpen = false;
      cancelAnimationFrame(raf);
      layer.classList.remove('is-open', 'is-paused', 'is-dragging');
      sheet.style.transform = '';
      bg.style.opacity = '';
      document.documentElement.classList.remove('hpv-locked');
      v.pause();
      timer = setTimeout(function () {
        layer.hidden = true;
        try { v.currentTime = 0; } catch (e) {}
        prog.style.width = '0';
      }, REDUCED.matches ? 0 : 340);
      opener.focus({ preventScroll: true });
    }
    /* Schliessen ueber die Seite: Verlaufseintrag zuruecknehmen, popstate schliesst dann */
    function close() {
      if (!isOpen) return;
      if (pushed) { pushed = false; shut(); history.back(); } else shut();
    }
    window.addEventListener('popstate', function () { if (isOpen) { pushed = false; shut(); } });

    opener.addEventListener('click', open);
    bg.addEventListener('click', close);
    x.addEventListener('click', function (e) { e.stopPropagation(); close(); });
    snd.addEventListener('click', function (e) {
      e.stopPropagation();
      v.muted = !v.muted;
      snd.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
      snd.setAttribute('aria-label', snd.getAttribute(v.muted ? 'data-l-on' : 'data-l-off'));
      if (v.paused) play();
    });
    document.addEventListener('keydown', function (e) { if (isOpen && e.key === 'Escape') close(); });

    /* Finger auf dem Sheet: kurzer Tipp = Pause/Weiter, nach unten ziehen = Sheet folgt, ab 25 % schliessen, sonst zurueckfedern */
    var y0 = null, x0 = 0, dy = 0, moved = false, t0 = 0;
    sheet.addEventListener('touchstart', function (e) {
      if (e.target.closest('button') || e.touches.length > 1) { y0 = null; return; }
      y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; dy = 0; moved = false; t0 = Date.now();
    }, { passive: true });
    sheet.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      var ddx = e.touches[0].clientX - x0;
      dy = e.touches[0].clientY - y0;
      if (!moved && (Math.abs(dy) > 8 || Math.abs(ddx) > 8)) { moved = true; layer.classList.add('is-dragging'); }
      if (!moved) return;
      e.preventDefault();
      var d = Math.max(0, dy);
      sheet.style.transform = 'translateY(' + d + 'px)';
      bg.style.opacity = String(Math.max(0, 1 - d / (sheet.offsetHeight || 1)));
    }, { passive: false });
    function end() {
      if (y0 === null) return;
      y0 = null;
      layer.classList.remove('is-dragging');
      if (!moved) return;
      var fast = dy / Math.max(1, Date.now() - t0) > 0.5;
      if (dy > (sheet.offsetHeight || 600) * 0.25 || (fast && dy > 40)) close();
      else { sheet.style.transform = ''; bg.style.opacity = ''; }
    }
    sheet.addEventListener('touchend', end);
    sheet.addEventListener('touchcancel', end);
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('button') || moved) return;
      if (v.paused) play(); else v.pause();
    });
  }

  /* ---------- Bilder gross oeffnen (Handy, B1): helles Vollbild beim angetippten Bild, wischen mit Einrasten, Zaehler, Vorschaubilder,
     Doppeltippen (2x) und zwei Finger zum Zoomen, vergroessert verschiebt der Finger das Bild.
     Schliessen: X, nach unten ziehen (ab 120 px), Escape, Zurueck (Eintrag im Verlauf). Danach steht die Galerie beim zuletzt gesehenen Bild. ---------- */
  function ImageView(layer, track) {
    document.body.appendChild(layer);
    var sc = layer.querySelector('[data-hpv-iv-sc]');
    var imgs = sc.querySelectorAll('img');
    var thumbs = layer.querySelectorAll('[data-hpv-iv-th] button');
    var thRow = layer.querySelector('[data-hpv-iv-th]');
    var cnt = layer.querySelector('[data-hpv-iv-cnt]');
    var xBtn = layer.querySelector('[data-hpv-iv-close]');
    var inner = layer.querySelector('[data-hpv-iv-in]');
    var bgEl = layer.querySelector('[data-hpv-iv-bg]');
    var gSlides = Array.prototype.filter.call(track.querySelectorAll('[data-hpv-slide]'), function (sl) { return !sl.classList.contains('hpv-gal__slide--video'); });
    var N = imgs.length, cur = 0, isOpen = false, pushed = false, timer = 0, opener = null;
    var Z = { s: 1, tx: 0, ty: 0 };

    function load(k) { var im = imgs[k]; if (im && !im.getAttribute('src')) im.src = im.getAttribute('data-src'); }
    function W() { return sc.clientWidth || window.innerWidth; }
    function apply(k) { var im = imgs[k]; if (im) im.style.transform = (Z.s > 1 || Z.tx || Z.ty) ? 'translate(' + Z.tx + 'px,' + Z.ty + 'px) scale(' + Z.s + ')' : ''; }
    function resetZoom() { if (Z.s !== 1 || Z.tx || Z.ty) { Z.s = 1; Z.tx = 0; Z.ty = 0; apply(cur); } layer.classList.remove('is-zoomed'); }
    function clamp() {
      var w = sc.clientWidth, h = sc.clientHeight, mx = (Z.s - 1) * w / 2, my = (Z.s - 1) * h / 2;
      Z.tx = Math.max(-mx, Math.min(mx, Z.tx)); Z.ty = Math.max(-my, Math.min(my, Z.ty));
    }
    function mark(k) {
      if (k !== cur) { var old = cur; cur = k; Z.s = 1; Z.tx = 0; Z.ty = 0; apply(old); layer.classList.remove('is-zoomed'); }
      cur = k;
      if (cnt) cnt.textContent = (k + 1) + ' / ' + N;
      for (var i = 0; i < thumbs.length; i++) {
        thumbs[i].classList.toggle('is-on', i === k);
        thumbs[i].setAttribute('aria-current', i === k ? 'true' : 'false');
      }
      var t = thumbs[k];
      if (t && thRow) {
        var l = t.offsetLeft - 16, r = t.offsetLeft + t.offsetWidth + 16 - thRow.clientWidth;
        if (thRow.scrollLeft > l) thRow.scrollLeft = l; else if (thRow.scrollLeft < r) thRow.scrollLeft = r;
      }
      load(k); load(k - 1); load(k + 1);
    }
    var ticking = false;
    sc.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; mark(Math.max(0, Math.min(N - 1, Math.round(sc.scrollLeft / W())))); });
    }, { passive: true });
    Array.prototype.forEach.call(thumbs, function (b, i) {
      b.addEventListener('click', function () { sc.scrollTo({ left: i * W(), behavior: REDUCED.matches ? 'auto' : 'smooth' }); });
    });

    function open(k) {
      if (isOpen) return;
      isOpen = true;
      clearTimeout(timer);
      opener = document.activeElement;
      layer.hidden = false;
      resetPull();
      document.documentElement.classList.add('hpv-locked');
      cur = -1;
      sc.scrollLeft = k * W();
      mark(k);
      void layer.offsetWidth;
      layer.classList.add('is-open');
      xBtn.focus({ preventScroll: true });
      try { history.pushState({ hpvImages: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
    }
    function shut() {
      if (!isOpen) return;
      isOpen = false;
      resetZoom();
      layer.classList.remove('is-open', 'is-gesture', 'is-pull', 'is-settle');
      document.documentElement.classList.remove('hpv-locked');
      /* Galerie der Seite aufs zuletzt gesehene Bild (Pille und Punkte folgen ueber das Scroll-Ereignis der Galerie) */
      var g = gSlides[cur];
      if (g) track.scrollTo({ left: g.offsetLeft, behavior: 'auto' });
      timer = setTimeout(function () { layer.hidden = true; resetPull(); }, REDUCED.matches ? 0 : 240);
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }
    function close() {
      if (!isOpen) return;
      if (pushed) { pushed = false; shut(); history.back(); } else shut();
    }
    window.addEventListener('popstate', function () { if (isOpen) { pushed = false; shut(); } });
    xBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') sc.scrollTo({ left: Math.max(0, Math.min(N - 1, cur + (e.key === 'ArrowRight' ? 1 : -1))) * W() });
    });

    /* Galerie: Tipp (ohne Wischen) oeffnet beim angetippten Bild */
    var gx = 0, gy = 0, gs = 0, gMoved = false;
    track.addEventListener('touchstart', function (e) { gx = e.touches[0].clientX; gy = e.touches[0].clientY; gs = track.scrollLeft; gMoved = false; }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (Math.abs(e.touches[0].clientX - gx) > 10 || Math.abs(e.touches[0].clientY - gy) > 10) gMoved = true;
    }, { passive: true });
    track.addEventListener('click', function (e) {
      if (!window.matchMedia('(max-width: 740px)').matches) return;
      if (gMoved || Math.abs(track.scrollLeft - gs) > 10) { gMoved = false; return; }
      var sl = e.target.closest('[data-hpv-slide]');
      var k = gSlides.indexOf(sl);
      if (k < 0) return;
      open(k);
    });
    /* Vergroessern-Knopf (Ketten-Set): oeffnet beim gerade sichtbaren Bild */
    var zbBtn = track.parentNode.querySelector('[data-hpv-zb]');
    if (zbBtn) zbBtn.addEventListener('click', function () {
      var k = Math.max(0, Math.min(gSlides.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
      open(k);
    });

    /* Finger in der Grossansicht: Doppeltippen, zwei Finger zoomen, vergroessert verschieben (nur im Bild).
       Nach unten ziehen (ueberall): der ganze Inhalt (Zaehler, X, Bild, Vorschaubilder) folgt dem Finger, die helle Flaeche blendet aus,
       ab 120 px oder schnellem Wisch faehrt alles nach unten raus, sonst federt es zurueck. Bewegung per requestAnimationFrame, nur transform/opacity. */
    var mode = null, inSc = false, sx = 0, sy = 0, st = 0, d0 = 0, s0 = 1, tx0 = 0, ty0 = 0, lastTap = 0, lastX = 0, lastY = 0, pull = 0, mx0 = 0, my0 = 0, H = 0, frame = 0;
    function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }
    function resetPull() {
      layer.classList.remove('is-pull', 'is-settle', 'is-out');
      inner.style.transform = '';
      bgEl.style.opacity = '';
      pull = 0;
    }
    function paint() {
      frame = 0;
      inner.style.transform = 'translate3d(0,' + pull + 'px,0)';
      bgEl.style.opacity = String(Math.max(0, 1 - pull / (H * 0.8)));
    }
    var zoomFrame = 0;
    function zoomPaint() { zoomFrame = 0; apply(cur); }
    function zoomLater() { if (!zoomFrame) zoomFrame = requestAnimationFrame(zoomPaint); }
    inner.addEventListener('touchstart', function (e) {
      var t = e.touches;
      inSc = !!e.target.closest('[data-hpv-iv-sc]');
      if (e.target.closest('button') && !e.target.closest('[data-hpv-iv-th]')) { mode = null; return; }
      if (t.length === 2) {
        if (!inSc) { mode = null; return; }
        mode = 'pinch'; d0 = dist(t) || 1; s0 = Z.s; tx0 = Z.tx; ty0 = Z.ty;
        var r = sc.getBoundingClientRect();
        mx0 = (t[0].clientX + t[1].clientX) / 2 - r.left - r.width / 2;
        my0 = (t[0].clientY + t[1].clientY) / 2 - r.top - r.height / 2;
        layer.classList.add('is-gesture');
        return;
      }
      if (t.length !== 1) return;
      sx = t[0].clientX; sy = t[0].clientY; st = Date.now(); tx0 = Z.tx; ty0 = Z.ty;
      mode = (Z.s > 1 && inSc) ? 'pan' : 'maybe';
      if (mode === 'pan') layer.classList.add('is-gesture');
    }, { passive: true });
    inner.addEventListener('touchmove', function (e) {
      var t = e.touches;
      if (mode === 'pinch' && t.length === 2) {
        e.preventDefault();
        var s = Math.max(1, Math.min(4, s0 * dist(t) / d0));
        /* Punkt unter den Fingern bleibt stehen */
        Z.tx = mx0 - (mx0 - tx0) * s / s0; Z.ty = my0 - (my0 - ty0) * s / s0; Z.s = s;
        clamp(); zoomLater();
        layer.classList.toggle('is-zoomed', Z.s > 1.01);
        return;
      }
      if (t.length !== 1 || !mode) return;
      var dx = t[0].clientX - sx, dy = t[0].clientY - sy;
      if (mode === 'pan') { e.preventDefault(); Z.tx = tx0 + dx; Z.ty = ty0 + dy; clamp(); zoomLater(); return; }
      if (mode === 'maybe' && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        mode = (dy > 0 && Math.abs(dy) > Math.abs(dx)) ? 'pull' : 'swipe';
        if (mode === 'pull') { H = window.innerHeight || 800; sy = t[0].clientY; layer.classList.add('is-pull'); }
      }
      if (mode === 'pull') {
        if (e.cancelable) e.preventDefault();
        pull = Math.max(0, t[0].clientY - sy);
        if (!frame) frame = requestAnimationFrame(paint);
      }
    }, { passive: false });
    function end(e) {
      var m = mode;
      if (m === 'pinch') {
        if (e.touches.length) return;
        layer.classList.remove('is-gesture');
        if (Z.s < 1.05) resetZoom();
        mode = null;
        return;
      }
      if (m === 'pan') { layer.classList.remove('is-gesture'); mode = null; return; }
      if (m === 'pull') {
        mode = null;
        if (frame) { cancelAnimationFrame(frame); frame = 0; }
        var fast = pull / Math.max(1, Date.now() - st) > 0.6;
        layer.classList.remove('is-pull');
        if (pull > 120 || (fast && pull > 40)) {
          /* raus nach unten, Flaeche ganz aus, dann schliessen */
          layer.classList.add('is-out');
          inner.style.transform = 'translate3d(0,' + H + 'px,0)';
          bgEl.style.opacity = '0';
          setTimeout(close, REDUCED.matches ? 0 : 240);
        } else {
          layer.classList.add('is-settle');
          inner.style.transform = '';
          bgEl.style.opacity = '';
          setTimeout(function () { layer.classList.remove('is-settle'); }, 270);
        }
        pull = 0;
        return;
      }
      if (m === 'maybe' && inSc && Date.now() - st < 300) {
        /* Doppeltippen: 2x an der Stelle, nochmal = zurueck */
        var now = Date.now(), ch = e.changedTouches[0];
        if (now - lastTap < 300 && Math.abs(ch.clientX - lastX) < 30 && Math.abs(ch.clientY - lastY) < 30) {
          if (e.cancelable) e.preventDefault();
          if (Z.s > 1) resetZoom();
          else {
            var r = sc.getBoundingClientRect();
            var px = ch.clientX - r.left - r.width / 2, py = ch.clientY - r.top - r.height / 2;
            Z.s = 2; Z.tx = -px; Z.ty = -py; clamp(); apply(cur);
            layer.classList.add('is-zoomed');
          }
          lastTap = 0;
        } else { lastTap = now; lastX = ch.clientX; lastY = ch.clientY; }
      }
      mode = null;
    }
    inner.addEventListener('touchend', end);
    inner.addEventListener('touchcancel', end);
    /* Maus (Test am Rechner): Doppelklick zoomt */
    sc.addEventListener('dblclick', function (e) {
      if (Z.s > 1) { resetZoom(); return; }
      var r = sc.getBoundingClientRect();
      Z.s = 2; Z.tx = -(e.clientX - r.left - r.width / 2); Z.ty = -(e.clientY - r.top - r.height / 2); clamp(); apply(cur);
      layer.classList.add('is-zoomed');
    });
  }

  /* ---------- Desktop ab 741 px ---------- */
  function Desk(root, atc) {
    var buy = root.querySelector('.hpv-buy');

    /* Glas hell oder dunkel je Kachel: Helligkeit im Bereich ihrer Pille (Bild ganz, 2:3, object-fit cover, mittig) */
    function measureTile(slide) {
      var img = slide.querySelector('img[data-measure]');
      var pill = slide.querySelector('.hpv-pill--tile');
      if (!img || !pill) return;
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var iw = probe.naturalWidth, ih = probe.naturalHeight;
          var sr = slide.getBoundingClientRect(), pr = pill.getBoundingClientRect();
          var W = sr.width, H = sr.height;
          if (!W || !H) return;
          var opy = (getComputedStyle(img).objectPosition || '').split(' ')[1] || '50%';
          var fy = /%$/.test(opy) ? parseFloat(opy) / 100 : 0.5;
          var s = Math.max(W / iw, H / ih), ox = (W - iw * s) / 2, oy = (H - ih * s) * fy;
          var x0 = Math.max(0, Math.floor((pr.left - sr.left - ox) / s)), y0 = Math.max(0, Math.floor((pr.top - sr.top - oy) / s));
          var cw = Math.max(1, Math.min(iw - x0, Math.ceil(pr.width / s))), ch = Math.max(1, Math.min(ih - y0, Math.ceil(pr.height / s)));
          var c = document.createElement('canvas');
          c.width = cw; c.height = ch;
          var ctx = c.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(probe, x0, y0, cw, ch, 0, 0, cw, ch);
          var d = ctx.getImageData(0, 0, cw, ch).data, sum = 0, n = 0;
          for (var i = 0; i < d.length; i += 4) { sum += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]; n++; }
          var lum = sum / n / 255;
          pill.setAttribute('data-lum', lum.toFixed(2));
          pill.classList.toggle('is-dark', lum < 0.5);
        } catch (e) { /* kein Zugriff aufs Bild: helles Glas bleibt */ }
      };
      probe.src = img.getAttribute('data-measure');
    }
    Array.prototype.forEach.call(root.querySelectorAll('.hpv-gal__slide'), measureTile);
    /* Set: nach einem Wechsel die Pillen der neuen Bilder neu messen */
    root.__hpvTiles = function () { Array.prototype.forEach.call(root.querySelectorAll('.hpv-gal__slide'), measureTile); };

    /* Videos im Raster (Produktvideo an Platz 4, Produktmedien vom Typ Video): laden erst ca. 300 px vor dem Bildschirm
       und erst nach dem Laden der Seite (Kachel 4 ragt oft in den ersten Bildschirm), laufen ohne Ton in Schleife, Knopf haelt an.
       Bei "Bewegung reduzieren" kein Autoplay. Produktvideo: 720p, bei Fehler die 1080p-Datei. */
    var pageLoaded = document.readyState === 'complete';
    if (!pageLoaded) window.addEventListener('load', function () { pageLoaded = true; }, { once: true });
    Array.prototype.forEach.call(root.querySelectorAll('[data-hpv-fv] video, .hpv-gal__slide--video video'), function (v) {
      var tile = v.parentNode;
      var btn = tile.querySelector('[data-hpv-vbtn]');
      var held = REDUCED.matches;
      var near = false;
      v.muted = true;
      if (v.getAttribute('data-poster')) v.poster = v.getAttribute('data-poster');
      function load() { if (v.getAttribute('data-src') && !v.getAttribute('src')) v.src = v.getAttribute('data-src'); }
      function play() {
        if (!pageLoaded) { window.addEventListener('load', function () { if (!held && near) play(); }, { once: true }); return; }
        load(); var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      v.addEventListener('error', function () {
        var hd = v.getAttribute('data-src-hd');
        if (!hd || v.getAttribute('src') === hd) return;
        v.src = hd;
        if (!held) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
      function mark() {
        if (!btn) return;
        var paused = v.paused;
        btn.classList.toggle('is-paused', paused);
        btn.setAttribute('aria-label', btn.getAttribute(paused ? 'data-l-play' : 'data-l-pause'));
      }
      v.addEventListener('play', mark);
      v.addEventListener('pause', mark);
      mark();
      if (btn) btn.addEventListener('click', function () {
        if (v.paused) { held = false; near = true; pageLoaded = true; play(); } else { held = true; v.pause(); }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          near = en[0].isIntersecting;
          if (near && !held) play();
          else if (!near && !v.paused) v.pause();
        }, { rootMargin: '300px 0px' }).observe(tile);
      } else if (!held) play();
    });

    /* Kundenvideos: erste sechs Beitraege des Abschnitts sh_story_section, Tipp klickt dessen Beitrag (oeffnet die Vorschau des Themes) */
    var ugc = root.querySelector('[data-hpv-ugc]');
    var items = document.querySelectorAll('[id^="sh-section-"] [class^="sh-story-item-"]');
    if (ugc && items.length) {
      var grid = ugc.querySelector('[data-hpv-ugc-grid]');
      var label = ugc.getAttribute('data-label') || '';
      for (var i = 0; i < Math.min(6, items.length); i++) {
        (function (it) {
          var src = it.querySelector('img');
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'hpv-ugc__t';
          b.setAttribute('aria-label', label);
          var im = document.createElement('img');
          im.alt = '';
          im.loading = 'lazy';
          /* Adresse aus data-sh-src (laedt dort erst in der Naehe), hier ebenso erst ab 300 px vor dem Raster */
          var url = src ? (src.getAttribute('data-sh-src') || src.getAttribute('src') || '') : '';
          if (url.indexOf('data:') === 0) url = '';
          im.setAttribute('data-hpv-ugc-src', url);
          im.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
          b.appendChild(im);
          if (it.getAttribute('data-type') === 'video') b.insertAdjacentHTML('beforeend', '<span class="hpv-ugc__p" aria-hidden="true"><svg width="10" height="10" viewBox="0 0 24 24" fill="#111" focusable="false"><path d="M8 5.5v13l10.5-6.5z"/></svg></span>');
          b.addEventListener('click', function () { it.click(); });
          grid.appendChild(b);
        })(items[i]);
      }
      var ugcImgs = grid.querySelectorAll('img[data-hpv-ugc-src]');
      var ugcShow = function (img) { var u = img.getAttribute('data-hpv-ugc-src'); img.removeAttribute('data-hpv-ugc-src'); if (u) img.src = u; };
      if ('IntersectionObserver' in window) {
        var ugcIo = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) { Array.prototype.forEach.call(ugcImgs, ugcShow); ugcIo.disconnect(); }
        }, { rootMargin: '300px 0px' });
        ugcIo.observe(grid);
      } else Array.prototype.forEach.call(ugcImgs, ugcShow);
      var all = ugc.querySelector('[data-hpv-ugc-all]');
      if (all) all.addEventListener('click', function () { items[0].click(); });
      ugc.hidden = false;
      var src0 = items[0].closest('[id^="shopify-section-"]');
      if (src0) src0.classList.add('hpv-ugc-src');
    }

    /* Mitlaufen: Oben-Abstand = min(Kopfhoehe + 24, Fensterhoehe - Spaltenhoehe - 24). So laeuft die Spalte mit,
       bis ihr Ende (Kundenvideos) zu sehen ist, und steht dann, bis das Bildraster zu Ende ist. */
    /* Kopfhoehe: was oben klebt (Ankuendigungsleiste der App, Kopfzeile, falls sticky) */
    var heads = document.querySelectorAll('#shopify-section-header, #shopify-section-header > *, store-header, [id^="shopify-section-"][class*="header"], [id^="shopify-section-"][class*="announcement"]');
    function headOff() {
      var h = 0;
      for (var i = 0; i < heads.length; i++) {
        var p = getComputedStyle(heads[i]).position;
        if (p !== 'sticky' && p !== 'fixed') continue;
        var r = heads[i].getBoundingClientRect();
        if (r.top <= 1 && r.bottom > h) h = r.bottom;
      }
      return Math.round(h);
    }
    var bar = root.querySelector('[data-hpv-bar]');
    var barOn = false, head = -1;
    function update() {
      var ho = headOff();
      if (ho !== head) { head = ho; root.style.setProperty('--hpv-head', ho + 'px'); }
      root.style.setProperty('--hpv-top', Math.min(ho + 24, window.innerHeight - buy.offsetHeight - 24) + 'px');
      if (!bar) return;
      var on = buy.getBoundingClientRect().bottom < ho;
      if (on === barOn) return;
      barOn = on;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }
    var queued = false;
    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; update(); });
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(buy);
    update();

    /* Leiste: derselbe Warenkorb-Klick wie der grosse Knopf (gewaehlte Variante) */
    var barBtn = root.querySelector('[data-hpv-bar-atc]');
    if (barBtn && atc) barBtn.addEventListener('click', function () { atc.click(); });
  }

  /* ---------- Kunden-Vorschau ("Ueber 90.000 Kunden tragen #HNDS", Theme-Abschnitt sh_story_section):
     links/rechts wischen = Pfeile, nach unten ziehen = schliessen. Der Abschnitt selbst bleibt unveraendert,
     hier werden nur seine Pfeile und sein X angetippt. ---------- */
  function StorySwipe(overlay) {
    var content = overlay.firstElementChild;
    var prev = overlay.querySelector('[class*="sh-nav-prev-"]');
    var next = overlay.querySelector('[class*="sh-nav-next-"]');
    var close = overlay.querySelector('[class*="sh-close-btn-"]');
    if (!content || !prev || !next || !close) return;
    var BLUR = 10, EASE = 'cubic-bezier(.2,.8,.2,1)';
    var x0 = 0, y0 = 0, t0 = 0, dx = 0, dy = 0, axis = null, busy = false;

    function set(tx, ty, ms) {
      content.style.transition = ms ? 'transform ' + ms + 'ms ' + EASE : 'none';
      content.style.transform = (tx || ty) ? 'translate3d(' + tx + 'px,' + ty + 'px,0)' : '';
    }
    function blur(px, ms) {
      overlay.style.transition = ms ? 'backdrop-filter ' + ms + 'ms ' + EASE + ',-webkit-backdrop-filter ' + ms + 'ms ' + EASE : 'none';
      overlay.style.backdropFilter = overlay.style.webkitBackdropFilter = 'blur(' + px + 'px)';
    }
    function reset() { set(0, 0, 0); blur(BLUR, 0); busy = false; }
    function later(fn, ms) { setTimeout(fn, REDUCED.matches ? 0 : ms); }

    overlay.addEventListener('touchstart', function (e) {
      if (busy || e.touches.length > 1) { axis = 'none'; return; }
      if (e.target.closest('[class*="sh-nav-arrow-"],[class*="sh-close-btn-"],[class*="sh-popup-button-"]')) { axis = 'none'; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = Date.now(); dx = dy = 0; axis = null;
    }, { passive: true });

    overlay.addEventListener('touchmove', function (e) {
      if (axis === 'none') return;
      dx = e.touches[0].clientX - x0; dy = e.touches[0].clientY - y0;
      if (!axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : (dy > 0 ? 'y' : 'none');
        if (axis === 'none') return;
      }
      e.preventDefault();
      if (axis === 'x') set(dx, 0, 0);
      else {
        var d = Math.max(0, dy);
        set(0, d, 0);
        blur(BLUR * Math.max(0, 1 - d / 300), 0);
      }
    }, { passive: false });

    function end() {
      if (!axis || axis === 'none') { axis = null; return; }
      var ms = Math.max(1, Date.now() - t0), W = window.innerWidth, H = window.innerHeight;
      if (axis === 'x') {
        if (Math.abs(dx) > 60 || Math.abs(dx) / ms > 0.5) {
          var dir = dx < 0 ? 1 : -1;
          busy = true;
          set(-dir * W, 0, 200);
          later(function () {
            (dir > 0 ? next : prev).click();   /* Theme wechselt Bild/Video (stoppt ein laufendes Video) */
            set(dir * W, 0, 0);
            void content.offsetWidth;
            set(0, 0, 260);
            later(function () { busy = false; }, 260);
          }, 200);
        } else set(0, 0, 220);
      } else {
        if (dy > 100 || dy / ms > 0.5) {
          busy = true;
          set(0, H, 220);
          blur(0, 220);
          later(function () { close.click(); reset(); }, 220);
        } else { set(0, 0, 220); blur(BLUR, 220); }
      }
      axis = null;
    }
    overlay.addEventListener('touchend', end);
    overlay.addEventListener('touchcancel', end);
  }

  function initAll() {
    /* Handy und Desktop; was nur am Desktop gilt, laeuft in Desk() */
    Array.prototype.forEach.call(document.querySelectorAll('[data-hpv]'), function (root) {
      if (root.__hpv) return;
      root.__hpv = true;
      Hpv(root);
    });
    /* Wisch-Gesten in der Kunden-Vorschau nur am Handy */
    if (!window.matchMedia('(max-width: 740px)').matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('[id^="sh-popup-overlay-"]'), function (overlay) {
      if (overlay.__hpvSwipe) return;
      overlay.__hpvSwipe = true;
      StorySwipe(overlay);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
